import Vue from 'vue'
import VueRouter from 'vue-router'
//import HomeView from '../views/HomeView.vue'
import IndexViewVue from '@/views/indexView.vue'
import allGameViewVue from '@/views/allGame/allGameViewVue.vue'
import oneGameViewVue from '@/views/allGame/oneGameView.vue'
import twoGameViewVue from '@/views/allGame/twoGameView.vue'
import threeGameViewVue from '@/views/allGame/threeGameView.vue'
import privacyGameView from '@/views/allGame/privacyGameView.vue'
import userAgreementGameViewVue from '@/views/allGame/UserAgreementGameView.vue'
import childrenPolicyViewVue from '@/views/privacyAgreement/childrenPolicyView.vue'/* 必须在views的文件夹下，在其他文件的子文件下无法读取 */
import thirdPartyViewVue from '@/views/privacyAgreement/thirdPartyView.vue'
import personalInformationViewVue from '@/views/privacyAgreement/personalInformationView.vue'
import mkqy02GameVue from '@/views/allGame/mkqy02GameVue.vue'
import fzwlqx03GameVue from '@/views/allGame/fzwlqx03GameVue.vue'
import ai02WJZHGameVue from '@/views/allGame/ai02WJZHGameVue.vue'
import download1Vue from '@/views/allGame/download1Vue.vue'

Vue.use(VueRouter)

const routes = [
  // 👇 直接让 /privacy 访问隐私政策（最干净的链接）
  { path: '/privacyGameView', redirect: '/privacy' },//在路由里加一条，访问旧地址自动跳到新地址：访问/privacyGameView需要重定向
  {
    path: '/privacy',
    name: 'privacyGameView',
    component: privacyGameView
  },
  {
    path: '/IndexViewVue',
    name: 'IndexViewVue',
    component: IndexViewVue
  },
  { path: '/', redirect: '/IndexViewVue'},
  { path: '/allGameViewVue', name: 'allGameViewVue', component: allGameViewVue},
  { path: '/oneGameViewVue', name: 'oneGameViewVue', component: oneGameViewVue},
  { path: '/twoGameViewVue', name: 'twoGameViewVue', component: twoGameViewVue},
  { path: '/threeGameViewVue', name: 'threeGameViewVue', component: threeGameViewVue},
  /* { path: '/privacyGameView', name: 'privacyGameView', component: privacyGameView  }, */
  { path: '/userAgreementGameViewVue', name: 'userAgreementGameViewVue', component: userAgreementGameViewVue  },
  { path: '/childrenPolicyViewVue', name: 'childrenPolicyViewVue', component: childrenPolicyViewVue  },
  { path: '/thirdPartyViewVue', name: 'thirdPartyViewVue', component: thirdPartyViewVue},
  { path: '/personalInformationViewVue', name: 'personalInformationViewVue', component: personalInformationViewVue},
  { path: '/mkqy02GameVue', name: 'mkqy02GameVue', component: mkqy02GameVue},
  { path: '/fzwlqx03GameVue', name: 'fzwlqx03GameVue', component: fzwlqx03GameVue},
  { path: '/ai02WJZHGameVue', name: 'ai02WJZHGameVue', component: ai02WJZHGameVue},
  { path: '/download1Vue', name: 'download1Vue', component: download1Vue},
  


]

const router = new VueRouter({
  mode: 'history', // ✅ 加上这一行，立刻去掉 /#/  https://mzs....com/#/IndexViewVue 有这个"/#/"哪里来的
  routes,
  scrollBehavior() {
    // 强制页面跳转时滚动到顶部
    return { x: 0, y: 0 };
  }
})

export default router
